import React, { useState, useEffect } from "react";
import QtyProduct from "./QtyProduct";
import { useTranslation } from "react-i18next";
import { imgUrl } from "../config/api";

const ProductCard = ({
  product,
  productId,
  title,
  price,
  image,
  initialColor,
  DiscountedPrice,
  colors = [],
  onQtyChange,
}) => {
  const { t, i18n } = useTranslation();
  const [showOptions, setShowOptions] = useState(false);
  const [selectedColor, setSelectedColor] = useState(initialColor || "White");
  const [activeColor, setActiveColor] = useState(initialColor || "White");
  const [selectedImg, setSelectedImg] = useState(image || imgUrl(image));
  const [quantity, setQuantity] = useState(0);
  const [totalPrice, setTotalPrice] = useState(price);
  const [selectedColorInfo, setSelectedColorInfo] = useState(null);

  const toggleOptions = () => {
    setShowOptions(!showOptions);
  };

  const handleColorSelect = (color) => {
    const newColorName = i18n.language === "en" ? color.ColorEnName : color.ColorName;
    setSelectedColor(newColorName);
    setActiveColor(newColorName);

    setSelectedColorInfo(color);

    const photoWithOrderZero = color.Photos.find((photo) => photo.PhotoOrder === 0);
    if (photoWithOrderZero) {
      setSelectedImg(photoWithOrderZero.PhotoUrl || image);
    } else {
      console.log("آیتمی با PhotoOrder برابر با ۰ پیدا نشد.");
    }
  };

  const isEnglish = i18n.language === "en";

  const formatPrice = (price) => {
    const priceInTomans = price / 10;
    if (isEnglish) {
      const formattedPrice = new Intl.NumberFormat("en").format(priceInTomans);
      return `${formattedPrice} Tomans`;
    } else {
      const formattedPrice = new Intl.NumberFormat("fa-IR").format(priceInTomans);
      return `${formattedPrice} تومان`;
    }
  };

  const getTranslatedColor = (color) => {
    return isEnglish ? color.ColorEnName : color.ColorName;
  };

  useEffect(() => {
    if (quantity >= 0) {
      const effectiveQuantity = quantity === 0 ? 1 : quantity;
      setTotalPrice(price * effectiveQuantity);

      if (onQtyChange) {
        const updatedProduct = {
          ...product,
          qty: quantity,
          totalPrice: price * effectiveQuantity,
          selectedColor: selectedColorInfo ? selectedColorInfo : initialColor,
        };

        if (quantity > 0) {
          onQtyChange(
            productId,
            quantity,
            price * effectiveQuantity,
            updatedProduct,
            selectedColorInfo ? selectedColorInfo : product
          );
        }
      }
    }
  }, [quantity, selectedColorInfo]);

  return (
    <div className="product-card">
      <div className="product-container-box">
        <div className="product-image-container">
          <img
            src={imgUrl(selectedImg)}
            alt={title}
            className="product-image"
          />
        </div>

        <div className="product-details">
          <h2 className="product-title">{title}</h2>
          <p className="product-color">
            {getTranslatedColor(
              colors.find(
                (color) => color.ColorEnName === selectedColor || color.ColorName === selectedColor
              )
            )}
          </p>
          <p
            className="product-price"
            style={price === DiscountedPrice ? {} : { textDecoration: "line-through" }}
          >
            {formatPrice(price)}
          </p>
          {price !== DiscountedPrice && (
            <p className="product-price" style={{ color: "#ca6667" }}>
              {formatPrice(DiscountedPrice)}
            </p>
          )}
          <QtyProduct qty={quantity} setQty={setQuantity} />
        </div>

        {!showOptions && (
          <div className="product-options2">
            <button className="options-btn2" onClick={toggleOptions}>
              {t("Show Options")}
            </button>
          </div>
        )}
      </div>

      {showOptions && (
        <div className="color-options">
          <p className="select-color-title">
            {t("Select Color")}:{" "}
            {getTranslatedColor(
              colors.find(
                (color) => color.ColorEnName === selectedColor || color.ColorName === selectedColor
              )
            )}
          </p>

          <div className="color-grid">
            {colors.length > 0 ? (
              colors.map((color) => {
                return (
                  <div
                    key={color.ColorName}
                    className={`color-box-container ${
                      activeColor === getTranslatedColor(color) ? "active" : ""
                    }`}
                    onClick={() => handleColorSelect(color)}
                  >
                    <div
                      className="color-box"
                      style={{
                        backgroundImage: `url(${imgUrl(
                          color.Photos?.find((photo) => photo.PhotoTypeId === 4709)?.PhotoUrl || ""
                        )})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    ></div>
                  </div>
                );
              })
            ) : (
              <p>{t("No Colors Available")}</p>
            )}
          </div>
        </div>
      )}

      {showOptions && (
        <div className="product-options">
          <button className="options-btn" onClick={toggleOptions}>
            {t("Collapse")}
          </button>
        </div>
      )}
    </div>
  );
};

export default ProductCard;
